import { atomFamily } from "jotai/utils";
import { atomWithImmer } from "jotai-immer";

import { type UpdateLensRequest } from "../../gql-generated/types";
import { type LensPreviewMediaItem } from "../../shared/state/LensPreviewMediaState";

export type LensEditableState = {
    -readonly [K in keyof Omit<
        UpdateLensRequest,
        "previewMediaResources" | "submissionId" | "lensName" | "lensId" | "releaseNote"
    >]: UpdateLensRequest[K];
} & {
    previewMediaItems?: LensPreviewMediaItem[];
};

export const defaultLensState: Partial<LensEditableState> = {
    creatorRewardProgramEnrolled: false,
    description: "",
    isGameUserProvided: false,
    lensCta: null,
    previewMediaItems: [],
    spectaclesTags: [],
    tags: [],
    profileVisibility: null,
};

export const lensStateAtom = atomFamily((_lensId: string) =>
    atomWithImmer<Partial<LensEditableState>>(defaultLensState),
);

export const lensEditedStateAtom = atomFamily((_lensId: string) =>
    atomWithImmer<Partial<LensEditableState>>(defaultLensState),
);

export interface ChangedField {
    field: keyof LensEditableState;
    label: string;
}
